import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["lazyload", "fillFrame", "src", "alt", "colorBlock", "fallbackContent", "aspectRatio", "width", "children"];
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { getLength, getSolidBackgroundShade } from 'utils/ui';
import { fillParent } from 'styles/mixins';
import { z } from 'styles/globals';
import ThemeSection from 'components/ThemeSection';
import LazyImage, { ImageWithLoader } from 'components/LazyImage';
import Box from 'components/Box';
function getRatioPercentage(ratio) {
  if (typeof ratio === 'string') {
    return ratio;
  }
  return "".concat(ratio * 100, "%");
}
function shouldForwardProp(prop) {
  return !['width', 'aspectRatio'].includes(prop);
}
var StyledBox = styled(Box).attrs({
  role: 'presentation'
}).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "CardImage__StyledBox",
  componentId: "sc-m2srgn-0"
})(["position:relative;display:block;width:", ";overflow:hidden;color:", ";", ""], function (p) {
  return p.width ? getLength(p.width) : '100%';
}, function (p) {
  return p.theme.text;
}, function (p) {
  return p.aspectRatio && css(["&::before{content:'';display:table;float:left;width:1px;margin-left:-1px;padding-bottom:", ";}"], getRatioPercentage(p.aspectRatio));
});
var Content = styled.div.withConfig({
  displayName: "CardImage__Content",
  componentId: "sc-m2srgn-1"
})(["", " z-index:", ";display:flex;align-items:center;justify-content:center;"], fillParent, z.flat);
function CardImage(_ref) {
  var _ref$lazyload = _ref.lazyload,
    lazyload = _ref$lazyload === void 0 ? true : _ref$lazyload,
    _ref$fillFrame = _ref.fillFrame,
    fillFrame = _ref$fillFrame === void 0 ? true : _ref$fillFrame,
    src = _ref.src,
    alt = _ref.alt,
    colorBlock = _ref.colorBlock,
    fallbackContent = _ref.fallbackContent,
    aspectRatio = _ref.aspectRatio,
    width = _ref.width,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var hasImage = !!src;
  var ImageComponent = lazyload ? LazyImage : ImageWithLoader;
  return /*#__PURE__*/React.createElement(ThemeSection, {
    name: fillFrame ? colorBlock : undefined,
    withBackgroundImage: hasImage
  }, /*#__PURE__*/React.createElement(StyledBox, _extends({
    width: width,
    backgroundColor: function backgroundColor(theme) {
      return hasImage ? theme.background : getSolidBackgroundShade(theme);
    },
    aspectRatio: aspectRatio
  }, otherProps), hasImage && /*#__PURE__*/React.createElement(ImageComponent
  // The key ensures that the component is
  // recreated when the `src` changes
  , {
    key: src,
    src: src,
    alt: alt,
    fillFrame: fillFrame
  }), (!hasImage || children) && /*#__PURE__*/React.createElement(Content, null, !hasImage && fallbackContent, children)));
}
export default CardImage;